module.exports = __WEBPACK_EXTERNAL_MODULE__69318__;